import { Status } from '@icon/Status';
import { FC } from 'react';
import { Description, Headline, NullMessageContainer, SVGContainer } from './styles';

interface NullResultsMessageProps {
  header: string;
  bodyText: string;
  isSVG?: boolean;
}

const NullResultsMessage: FC<NullResultsMessageProps> = ({ header, bodyText, isSVG }) => {
  return (
    <NullMessageContainer>
      {isSVG && (
        <SVGContainer>
          <Status embeddedIcon="search" />
        </SVGContainer>
      )}

      {header && <Headline>{header}</Headline>}

      {bodyText && <Description>{bodyText as string}</Description>}
    </NullMessageContainer>
  );
};

export default NullResultsMessage;
